module.exports = __webpack_public_path__ + "img/itx-file-type-bmp.8324520a.svg";